import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { AppMainService } from "../../../../app-main.service";
import { PurchasesService } from "../../../../inventory/purchases/purchases.service";
import { SalesOrderService } from "../../../../inventory/sales-order/sales-order.service";
import { CompanyBranchService } from '../../../../configurations/company-branch/company-branch.service';
import { Channel, RoutingPath, TransactionNames, typeJournalAddEditText } from "../../../../finance/constants/constants";
import { IJournalView } from "../../../../finance/models/journal.model";
import { firstValueFrom, Observable, Subject, takeUntil } from "rxjs";
import { AppMainComponent } from "../../../../app.main.component";
import { AccountService } from "src/app/accounts/accountService";
import { UtilsService } from "src/app/inventory/purchases/utility/utils.service";
import { ObjectNames } from "../../constants/object.names";
import { SharedChannelService } from "../../services/channel.service";
import { TitleCasePipe } from "@angular/common";
import { ChannelN } from "../../models/channel.model";
import { Severity } from "src/app/inventory/constants/constants";
import { ReceivePaymentDialogType } from "../receive-payments/constants/constants";
import { AccountModuleId } from "../../constants/modules.constant";
import { ClosingYearDisplayMessages } from "src/app/finance/constants/closing-year.constant";

@Component({
    selector: "app-inventory-module-overview-dialogs",
    templateUrl: "./inventory-module-overview-dialogs.component.html",
    styleUrls: ["./inventory-module-overview-dialogs.component.scss"],
    providers:[MessageService]
})
export class InventoryModuleOverviewDialogsComponent implements OnChanges, OnDestroy {
    @Input() displayOverview: boolean = false;
    @Input() overviewRefId: number = 0;
    @Input() overviewRefNumber: string = "";
    @Input() overviewModule: string = "";
    @Input() selectedInvTransRow: any ;
    @Input() selectedBillTransRow: any ;
    @Input() visibleFromModule: string = "";
    @Input() confirmVoid: boolean = false;
    @Input() poEdit: boolean = false;
    @Input() isShowVoidDelete: boolean = false;
    @Output() onCancel = new EventEmitter();
    @Output() onEdit = new EventEmitter();
    @Output() onSuccessfullAddEdit = new EventEmitter<typeJournalAddEditText>();
    invoiceAddEdit: boolean = false;
    baseCurrency: any = null;
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    invoiceDetails;
    estimateDetails;
    salesOrderDetails;
    creditMemoDetails;
    poDetails;
    rpoDetails;
    billPaymentDetails;
    billDetails;
    rmaDetails;

    transactionNames = TransactionNames;
    isView: boolean = true;

    //tracking
    savedOptionSelection = null;
    @Input() trackingOptions =[];
    utilityService: UtilsService;
    displayScanInfo: boolean = false;
    nameLists = [];
    autoGenerateLists = [];
    totalTBRecord: number = 0;
    rowsPerPageTB = [100, 200, 300, 500];
    pageSize: number = 100;
    pageNumber: number = 1;
    first: number = 0;

    displayInvoicingAdd: boolean = false;
    selectedInvoicing = {
        id: 0
    }
    fromReceivedItems: boolean = false;
    displayJournalEntryViewDialog: boolean = false;
    transactionMasterId: number = 0;
    allAccounts = [];
    sortBy: string = '';
    isAscending: string = 'false';
    searchValue: string = '';
    searchColumns: string = '';
    totalRecord: number;
    noCaseFindOrLoadingText = "Loading....";
    isJEVoided :boolean = false; 
    returnDialogType :string = '';
    returnDialogHeader :string = '';
    displayReturnAdd :boolean= false
    displayVendorCreditAddEditDialog :boolean= false ;
    vendorCreditDialogType  :string = "";
    vendorCreditDialogHeader :string = "";
    allowedOverviewModules = [this.transactionNames.Invoice,this.transactionNames.CreditMemo,this.transactionNames.Bill,this.transactionNames.BillPayment,this.transactionNames.ItemReceipt,this.transactionNames.CustomerRMA,this.transactionNames.SalesOrder,this.transactionNames.Estimate,this.transactionNames.PurchaseOrder];
    selectedChannel = null;
    displayReceivedPayment :boolean= false ;
    isBillPayment :boolean= false ;
    accountChannels = [];
    receivePaymentDialogType = ReceivePaymentDialogType;
    closingDateModuleName : string = "" ;
    statementMessage : string = "" ;
    closingDate : any ;
    constructor(
        private salesOrderService: SalesOrderService,
        private appMainService: AppMainService,
        private messageService: MessageService,
        private purchaseService: PurchasesService,
        private router: Router, private app: AppMainComponent,
        private companyService: CompanyBranchService,
        private confirmationService: ConfirmationService,
        private accountService: AccountService,
        private utilService: UtilsService,private sharedChannelService:SharedChannelService,private titlecasePipe: TitleCasePipe,
    ) { 
        this.utilityService = this.utilService;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.overviewRefNumber && changes.overviewRefNumber.currentValue) {
            this.overviewRefNumber = changes.overviewRefNumber.currentValue;
        }
        if (changes.overviewRefId) {
            this.overviewRefId = changes.overviewRefId?.currentValue || 0;
        }
        if (changes.displayOverview && changes.displayOverview.currentValue) {
            this.displayOverview = changes.displayOverview.currentValue;
            this.checkTransactionName();
        }
    }

    showSerialDetails(product, type) {
        this.fromReceivedItems = true;
        this.savedOptionSelection = product.serialSettings;
        this.displayScanInfo = true;
        this.nameLists = [];
        this.autoGenerateLists = [];
        const arr = [];
        if (type == 'receipt') {
            this.purchaseService.getItemReceiptProductSerialDetails(product.rpoId, product.productId, (product.type == 'product' ? 0 : product.subProductId)).subscribe(res => {
                res?.forEach((element) => {
                    const obj = {
                        id: element.id,
                        serialNo: element.barcode,
                        serialNo2: element.serialNumber2,
                        serialNo3: element.serialNumber3,
                        serialNo4: element.serialNumber4,
                        serialNo5: element.serialNumber5,
                        serialNo6: element.serialNumber6,
                        serialNo7: element.serialNumber7,
                        serialNo8: element.serialNumber8,
                        serialNo9: element.serialNumber9,
                        serialNo10: element.serialNumber10,
                        serialNo11: element.serialNumber11,
                        serialNo12: element.serialNumber12,
                        serialNo13: element.serialNumber13,
                        serialNo14: element.serialNumber14,
                        serialNo15: element.serialNumber15,
                        serialNo16: element.serialNumber16,
                        serialNo17: element.serialNumber17,
                        lotNo: element.lotNumber,
                        revisionNo: element.revisionNumber,
                        expiration: this.app._showDateTimeWithZone(element.expirationDate)
                    }
                    arr.push(obj);
                });
                this.autoGenerateLists = arr;
                this.nameLists = this.autoGenerateLists.slice(0, 100);
                this.totalTBRecord = this.autoGenerateLists?.length;
            })
        } else {
            this.purchaseService.getBillProductSerialDetails(product.billOrderId, product.productId, (product.type == 'product' ? 0 : product.subProductId)).subscribe(res => {
                res?.forEach((element) => {
                    const obj = {
                        id: element.id,
                        serialNo: element.barcode,
                        serialNo2: element.serialNumber2,
                        serialNo3: element.serialNumber3,
                        serialNo4: element.serialNumber4,
                        serialNo5: element.serialNumber5,
                        serialNo6: element.serialNumber6,
                        serialNo7: element.serialNumber7,
                        serialNo8: element.serialNumber8,
                        serialNo9: element.serialNumber9,
                        serialNo10: element.serialNumber10,
                        serialNo11: element.serialNumber11,
                        serialNo12: element.serialNumber12,
                        serialNo13: element.serialNumber13,
                        serialNo14: element.serialNumber14,
                        serialNo15: element.serialNumber15,
                        serialNo16: element.serialNumber16,
                        serialNo17: element.serialNumber17,
                        lotNo: element.lotNumber,
                        revisionNo: element.revisionNumber,
                        expiration: this.app._showDateTimeWithZone(element.expirationDate)
                    }
                    arr.push(obj);
                });
                this.autoGenerateLists = arr;
                this.nameLists = this.autoGenerateLists.slice(0, 100);
                this.totalTBRecord = this.autoGenerateLists?.length;
            })
        }
    }

    loadSerialsLazy(event) {
        if (this.autoGenerateLists) {
            this.nameLists = this.autoGenerateLists.slice(
                event.first,
                event.first + event.rows
            );
        }
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    fetchAllAccounts() {
        this.sortBy = "order";
        this.isAscending = "true";
        let filter = "allfinancialaccounts";
        const data = {
            pageNo: this.pageNumber,
            pageSize: this.pageSize,
            searchValue: this.searchValue,
            searchColumns: this.searchColumns,
            sortBy: this.sortBy,
            isAscending: this.isAscending,
            filter: filter,
            isActive: true,
            showBalance: false,
        };
        this.getAllAccounts(data);
      }
    
      getAllAccounts(data) {
        this.appMainService.isShowSpinner("loadAccounts");
        this.accountService
            .getAllAccountsWithPagination(data)
            .then((accounts) => {
                this.appMainService.isHideSpinner("loadAccounts");
                let { inventory, headers } = accounts;
                inventory = inventory == null ? [] : inventory;
                headers = headers == null ? [] : headers;
                this.totalRecord = headers["TotalCount"];
                this.noCaseFindOrLoadingText = "No Accounts found";
                this.allAccounts = inventory;
    
            })
            .finally(() => {
                this.appMainService.isHideSpinner("loadAccounts");
                this.noCaseFindOrLoadingText = "No Accounts found.";
            });
      }

    checkTransactionName() {
        if (this.displayOverview && (this.overviewRefId || this.overviewRefNumber) && this.overviewModule) {
            switch (this.overviewModule) {
                case this.transactionNames.Invoice:
                    this.getInvoiceDetailsById(this.overviewRefId, this.overviewRefNumber);
                    break;
                case this.transactionNames.Estimate:
                    this.getEstimateDetailsById(this.overviewRefId, this.overviewRefNumber);
                    break;
                case this.transactionNames.SalesOrder:
                    this.getSalesOrderDetailsById(this.overviewRefId, this.overviewRefNumber);
                    break;
                case this.transactionNames.CreditMemo:
                    this.getCrediMemoDetailsById(this.overviewRefId, this.overviewRefNumber);
                    break;
                case this.transactionNames.PurchaseOrder:
                    this.getPurchaseOrderDetailsById(this.overviewRefId);
                    break;
                case this.transactionNames.ItemReceipt:
                    this.getRPODetailsById(this.overviewRefId);
                    break;
                case this.transactionNames.BillPayment:
                    this.getBillPaymentDetailsById(this.overviewRefId);
                    break;
                case this.transactionNames.Bill:
                    this.getAllCurrencies();
                    this.getBillDetailsById(this.overviewRefId);
                    break;
                case this.transactionNames.BankRegister:
                    this.getBillDetailsById(this.overviewRefId);
                    break;
                case this.transactionNames.FundTransfer:
                    this.getBillDetailsById(this.overviewRefId);
                    break;
                case this.transactionNames.Deposit:
                    this.getBillDetailsById(this.overviewRefId);
                    break;
                case this.transactionNames.CustomerRMA:
                    this.getCustomerRMADetailsById(this.overviewRefId, this.overviewRefNumber);
                    break;
                case this.transactionNames.VendorRMA:
                    this.returnDialogType = 'VIEW';
                    this.returnDialogHeader = "View Vendor Return";
                    this.displayReturnAdd = true;
                    this.displayOverview = false;
                    break;
                case this.transactionNames.VendorCredit:
                    this.displayVendorCreditAddEditDialog = true ;
                    this.vendorCreditDialogHeader = "View Vendor Credit";
                    this.vendorCreditDialogType = 'VIEW';
                    this.displayOverview = false;
                    break;
                case this.transactionNames.JournalEntry:
                    this.fetchAllAccounts();
                    this.openJournalEntryDialog();
                    break;    
            }
        }
    }

    invoiceToReceivePayment(data) {
        if(this.selectedInvTransRow?.balanceDue  > 0){
                this.getAccountChannels(AccountModuleId);
                this.openReceivePaymentInvoice();
      }
    }

    billToBillPayment(data) {
        this.selectedBillTransRow.accountVendorId = this.billDetails?.vendorId ;
        this.selectedBillTransRow.referenceId = this.billDetails?.id ;
        if(this.selectedBillTransRow?.balanceDue  > 0){
            this.isBillPayment = true ;
      }
    }

    getAccountChannels(id: number) {
        this.sharedChannelService.getChannels(id).subscribe({
            next: (res: ChannelN[]) => {
                this.accountChannels = res;
            },
            error: (error) => {
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Error occurred...",
                });
            },
        });
      }
      onDeleteVendorCredit(data: { event: boolean; statementMessage: string }) {
        this.statementMessage = data?.statementMessage;
        this.voidDeleteEntry(data.event,this.overviewRefId,'deleteVendorCreditEntry',this.transactionNames.VendorCredit,"purchase");
    }
    isClosingStatementDate(event : string) {
        this.statementMessage = event ;
    }
    isVoidDeleteEntry(isVoid) {
        if (this.displayOverview && (this.overviewRefId || this.overviewRefNumber) && this.overviewModule) {
            const transactionConfig = {
                [this.transactionNames.Invoice]: {
                    moduleName: TransactionNames.Invoice,
                    details: this.invoiceDetails,
                    dateField: 'invoiceDate',
                    action: 'deleteInvoicing',
                    type: 'sales'
                },
                [this.transactionNames.CreditMemo]: {
                    moduleName: TransactionNames.CreditMemo,
                    details: this.creditMemoDetails,
                    dateField: 'creditMemoDate',
                    action: 'deleteCreditMemo',
                    type: 'sales'
                },
                [this.transactionNames.Bill]: {
                    moduleName: TransactionNames.Bill,
                    details: this.billDetails,
                    dateField: 'billDate',
                    action: 'voidBill',
                    type: 'purchase',
                },
                [this.transactionNames.BillPayment]: {
                    moduleName: TransactionNames.BillPayment,
                    details: this.billPaymentDetails,
                    dateField: 'billDate',
                    action: 'deleteBill',
                    type: 'purchase'
                },
                [this.transactionNames.ItemReceipt]: {
                    moduleName: TransactionNames.ItemReceipt,
                    details: this.rpoDetails,
                    dateField: 'createdDate',
                    action: 'voidRPO',
                    type: 'purchase',
                },
                [this.transactionNames.CustomerRMA]: {
                    moduleName: TransactionNames.CustomerRMA,
                    details: this.rmaDetails,
                    dateField: 'createdDate',
                    action: 'deleteCustomerReturn',
                    type: 'sales',
                },
                [this.transactionNames.SalesOrder]: {
                    moduleName: TransactionNames.SalesOrder,
                    details: this.salesOrderDetails,
                    dateField: 'salesOrderDate',
                    action: !isVoid ? 'deleteSalesOrder' : 'voidSalesOrder',
                    type: 'sales',
                },
                [this.transactionNames.Estimate]: {
                    moduleName: TransactionNames.Estimate,
                    details: this.estimateDetails,
                    dateField: 'estimateDate',
                    action: !isVoid ? 'deleteEstimate' : 'voidEstimate',
                    type: 'sales',
                },
                [this.transactionNames.PurchaseOrder]: {
                    moduleName: TransactionNames.PurchaseOrder,
                    details: this.poDetails,
                    dateField: 'poDate',
                    action: !isVoid ? 'deletePO' : 'voidPO',
                    type: 'purchase',
                }
            };
            
            const config = transactionConfig[this.overviewModule];
            if (config && config.details) {
                this.closingDateModuleName = config.moduleName;
    
                this.closingDate = this.app._showDateTimeWithZone(new Date(config.details[config.dateField]));
                
                this.voidDeleteEntry(isVoid, config.details?.id, config.action, config.moduleName, config.type);
            }
        }
    }
      openReceivePaymentInvoice(){
          this.selectedChannel = {
              name : ""
          }
          this.selectedInvoicing  = {
              ...this.selectedInvTransRow,
              id: this.selectedInvTransRow.referenceId
          };
          this.selectedChannel.name = "Invoicing" ;
          this.displayReceivedPayment = true;
      }

      onReceivePaymentsDialogClose(isSave) {
        this.onCancel.emit({});
        this.displayReceivedPayment = false;
        this.displayOverview = false;
    }

    closeDialog(isSave){
        this.isBillPayment = false
        if(isSave){
            this.displayOverview = false;
            this.onCancel.emit({});
        }
       }

    cancel(e) {
        this.isBillPayment = false
    }
    onVendorRmaSaveComplete(event) {
        this.displayReturnAdd = false;
        this.returnDialogType = "";
        this.onCancel.emit({});
    }

    onCloseVendorCreditDialog(e){
        this.displayVendorCreditAddEditDialog = false;
        this.onCancel.emit({});
      }

    onSuccessfullJournalAdd(e: typeJournalAddEditText) {
        if (e == 'Edit') {
          this.isView = true;
        }
        this.onSuccessfullAddEdit.emit(e);
        this.displayJournalEntryViewDialog = false;
        this.displayOverview = false;
    
      }

      openJournalEntryDialog() {
        this.overviewRefNumber = this.overviewRefNumber;
        this.transactionMasterId = this.overviewRefId;
        this.displayOverview = true;
        this.isView = true;
        this.displayJournalEntryViewDialog = true;
      }

    showEditJournalEntry() {
        this.isView = false;
      }

    navigateToDetails() {
        let key = "";
        switch (this.overviewModule) {
            case this.transactionNames.Invoice:
                key = "Invoice";
                break;
            case this.transactionNames.Estimate:
                key = "Estimate";
                break;
            case this.transactionNames.SalesOrder:
                key = "SalesOrder";
                break;
            case this.transactionNames.CreditMemo:
                key = "CreditMemo";
                break;
            case this.transactionNames.PurchaseOrder:
                key = "PurchaseOrder";
                break;
            case this.transactionNames.ItemReceipt:
                key = "ItemReceipt";
                break;
            case this.transactionNames.InventoryAdjustment:
                key = "InventoryAdjustment";
                break;
            case this.transactionNames.InventoryTransfer:
                key = "InventoryTransfer";
                break;
            case this.transactionNames.ReceivePayment:
                key = "ReceivePayment";
                break;
            case this.transactionNames.JournalEntry:
                key = "JournalEntry";
                break;
            case this.transactionNames.BillPayment:
                key = "BillPayment";
                break;
            case this.transactionNames.Bill:
                key = "Bill";
                break;
            case this.transactionNames.CustomerRMA:
                key = "CustomerRMA";
                break;
            case this.transactionNames.VendorRMA:
                key = "VendorRMA";
                break;
        }
        this.onDialogClose();
        this.router.navigate([RoutingPath[key]], {      
            queryParams: {
                id: this.overviewRefId,
                module: this.overviewModule,
                channelId: Channel[key],
                statusId: 1,
                globalSearch: true,
                data: this.overviewRefNumber
            },
        });
    }

    // for invoice
    showEditInvoice(overviewModule) {
        if (overviewModule == 'Invoice') {
            this.invoiceAddEdit = true
            this.selectedInvoicing.id = this.invoiceDetails.id;
        }
        this.displayInvoicingAdd = true;
    }


    showEditPurchases(overviewModule) {

        this.onEdit.emit({});
        this.displayOverview = false;
    }

    showEditSalesOrder(overviewModule) {
        this.onEdit.emit({});
        this.displayOverview = false;
    }

    checkVoidedJE(e){
        this.isJEVoided = e; 
     }

    voidInvoice() {
        this.confirmationService.confirm({
            message: "Do you want to void this Invoice?",
            header: "Void Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                this.salesOrderService
                    .deleteInvoicing(this.selectedInvoicing.id, true)
                    .then(() => {
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: "Voided Successfully...",
                        });
                        this.displayInvoicingAdd = false;
                        this.onSuccessfullAddEdit.emit();
                    })
                    .catch(() => {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Error occurred while deleting data...",
                        });
                    });
            },
            reject: () => { },
        });
    }
    voidDeleteEntry(isVoid, transId, functionName, txnName, moduleName) {
        const service = moduleName == 'sales' ? this.salesOrderService : this.purchaseService
        const isVoidStatus = isVoid == true ? 'Void' : 'Delete'
        this.confirmationService.confirm({
            message: `Do you want to ${isVoidStatus} this ${txnName}?`,
            header: `${isVoidStatus} Confirmation`,
            icon: "pi pi-exclamation-triangle",
            key :"account-transaction-dialogs",
            accept: () => {
                if (this.statementMessage) {
                    this.messageService.add({ severity: Severity.Warn, summary: this.titlecasePipe.transform(Severity.Warn), detail: ClosingYearDisplayMessages.voidDeleteMessage });
                } else {
                this.appMainService.isShowSpinner("voidDeleteEntry");
                let request$ = service[functionName](transId, isVoid);
                if (request$ instanceof Observable) {
                    request$ = firstValueFrom(request$); 
                }
                request$.then(() => {
                        this.appMainService.isHideSpinner("voidDeleteEntry");
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: `${isVoidStatus} ${txnName} Successfully...`,
                        });
                        this.displayInvoicingAdd = false;
                        this.displayOverview = false;
                        this.displayVendorCreditAddEditDialog = false;
                        // this.onSuccessfullAddEdit.emit();
                        this.onCancel.emit({});
                    })
                    .catch(() => {
                        this.appMainService.isHideSpinner("voidDeleteEntry");
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Error occurred while deleting data...",
                        });
                    });
                }
            },
            reject: () => { },
        });
    }
    onInvoiceCreateDialogClose() {
        this.displayInvoicingAdd = false;
        this.displayOverview = false;
        this.onSuccessfullAddEdit.emit();
    }

    onInvoiceDialogCancel() {
        this.displayInvoicingAdd = false;
    }
    getInvoiceDetailsById(id: number, no: string) {
        this.invoiceDetails = null;
        this.appMainService.isShowSpinner("loadDetails");

        const api = id ? this.salesOrderService.getInvoiceDetailsById(id) : this.salesOrderService.getInvoiceDetailsByNumber(no);
        api.pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                (res) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.invoiceDetails = res;
                    this.overviewRefId = res?.id;
                },
                (err) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.showErrorMsg(err);
                },
            );
    }

    getEstimateDetailsById(id: number, no: string) {
        this.estimateDetails = null;
        this.appMainService.isShowSpinner("loadDetails");
        const api = id ? this.salesOrderService.getEstimatesDetailsById(id) : this.salesOrderService.getEstimatesDetailsByNumber(no);
        api.pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                (res) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.estimateDetails = res;
                    this.overviewRefId = res?.id;
                },
                (err) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.showErrorMsg(err);
                },
            );
    }

    getSalesOrderDetailsById(id: number, no: string) {
        this.salesOrderDetails = null;
        this.appMainService.isShowSpinner("loadDetails");
        const api = id ? this.salesOrderService.getSalesOrderDetailsById(id) : this.salesOrderService.getSalesOrderDetailsByNumber(no);
        api.pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                (res) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.salesOrderDetails = res;
                    this.overviewRefId = res?.id;
                },
                (err) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.showErrorMsg(err);
                },
            );
    }

    getCrediMemoDetailsById(id: number, no: string) {
        this.creditMemoDetails = null;
        this.appMainService.isShowSpinner("loadDetails");
        const api = id ? this.salesOrderService.getCreditMemoById(id) : this.salesOrderService.getCreditMemoByNumber(no);
        api.pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                (res) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.creditMemoDetails = res;
                    this.overviewRefId = res?.id;
                },
                (err) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.showErrorMsg(err);
                },
            );
    }

    getPurchaseOrderDetailsById(id) {
        this.poDetails = null;
        this.appMainService.isShowSpinner("loadDetails");
        this.purchaseService.getPOById(id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                (res) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.poDetails = res;
                },
                (err) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.showErrorMsg(err);
                },
            );
    }

    getRPODetailsById(id) {
        this.rpoDetails = null;
        this.appMainService.isShowSpinner("loadDetails");
        this.purchaseService.getRPOById(id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                (res) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.rpoDetails = res;
                },
                (err) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.showErrorMsg(err);
                },
            );
    }

    getBillPaymentDetailsById(id) {
        this.billPaymentDetails = null;
        this.appMainService.isShowSpinner("loadDetails");
        this.purchaseService.getPaymentById(id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                (res) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.billPaymentDetails = res;
                },
                (err) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.showErrorMsg(err);
                },
            );
    }

    getBillDetailsById(id) {
        this.billDetails = null;
        this.appMainService.isShowSpinner("loadDetails");
        this.purchaseService.getBillById(id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                (res) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.billDetails = res;
                },
                (err) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.showErrorMsg(err);
                },
            );
    }

    getAllCurrencies() {
        this.companyService.getAllCurrencies().subscribe((res) => {
            if (res?.length) {
                this.baseCurrency = res.filter(
                    (r) => r.isBaseCurrency
                )[0];
                if (this.baseCurrency?.symbol) {
                    this.baseCurrency.symbol = this.baseCurrency.symbol.trim();
                }
            }
        });
    }

    getCustomerRMADetailsById(id: number, no: string) {
        this.billDetails = null;
        this.appMainService.isShowSpinner("loadDetails");
        const api = id ? this.salesOrderService.getCustomerReturnById(id) : this.salesOrderService.getCustomerReturnByNumber(no);
        api.pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                (res) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.rmaDetails = res;
                    this.overviewRefId = res?.id;
                },
                (err) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.showErrorMsg(err);
                },
            );
    }

    showWriteCheckDetails(id) {
        this.billDetails = null;
        this.appMainService.isShowSpinner("loadDetails");
        this.purchaseService.getBillById(id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                (res) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.billDetails = res;
                },
                (err) => {
                    this.appMainService.isHideSpinner("loadDetails");
                    this.showErrorMsg(err);
                },
            );
    }

    showErrorMsg(err) {
        this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: "Error occurred...",
        });
    }

    onDialogClose() {
        this.displayOverview = false;
        this.onCancel.emit({});
    }

    closeJournalList() {
        this.isView = true;
        this.onCancel.emit({});
    }

    updateJournalList(e: typeJournalAddEditText) {
        this.displayOverview = false;
    }

    showEditBillPayment() {
        this.isView = false;
    }
}
